
import { Logo } from './Logo';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-secondary/40 py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center">
          <Logo />
          <nav className="mt-8 mb-6">
            <ul className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
              <li>
                <Link to="/om-os" className="hover:text-foreground transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-foreground transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/privatlivspolitik" className="hover:text-foreground transition-colors">
                  Privatlivspolitik
                </Link>
              </li>
            </ul>
          </nav>
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Abonemt. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </footer>
  );
};
